// extracted by mini-css-extract-plugin
export default {"name":"field_name__-ZrD5","image":"field_image__tQAHc"};